import { format } from '@dynatrace-sdk/units';

import { isFormatterOptions } from '../../core/types/formatter.js';
import type { TreeMapFormatter } from '../types/internal.js';

export function getAppliedFormatter(formatter: TreeMapFormatter) {
  if (isFormatterOptions(formatter)) {
    return (value: number) => format(value, formatter);
  }

  return formatter;
}
